import { Glossary } from "../models/glossary";

export const glossary = new Glossary();
